var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Route } from 'react-router-dom';
export var AllowedURL = function AllowedURL(_a) {
  var feature = _a.feature,
      features = _a.features,
      siteId = _a.siteId,
      children = _a.children,
      rest = __rest(_a, ["feature", "features", "siteId", "children"]);

  return React.createElement(Route, Object.assign({}, rest, {
    render: function render() {
      return features[siteId][feature] ? children : window.location.assign("/404");
    }
  }));
};